jQuery(document).ready(function ($) {
  // Initially hide all FAQ content
  $('.z_faqContent').hide();

  // Click event for FAQ title
  $('.z_faqTitle').on('click', function () {
    // Get the parent .faq-item
    var faqItem = $(this).parent();

    // If the clicked item is already active
    if (faqItem.hasClass('active')) {
      faqItem.removeClass('active');
      faqItem.find('.z_faqContent').slideUp();
    } else {
      // Close any other open FAQ items
      $('.faq-item.active').removeClass('active').find('.z_faqContent').slideUp();

      // Open the clicked FAQ item
      faqItem.addClass('active');
      faqItem.find('.z_faqContent').slideDown();
    }
  });


  jQuery(document).on("click", "button#thirdPartyTestReport", function(){
     jQuery(".z_mainPopup").addClass("active"); 
  });

  jQuery(document).on("click", ".z_mainPopup .z_mainPopupBox .z_content ul.z_product_third_tabs li#australiaReportTab", function(){
    jQuery(this).addClass("active");
    jQuery("#inDepthReportTab").removeClass("active");

    jQuery("#third_australia").addClass("active");
    jQuery("#third_in-depth").removeClass("active");
  });

  jQuery(document).on("click", ".z_mainPopup .z_mainPopupBox .z_content ul.z_product_third_tabs li#inDepthReportTab", function(){
    jQuery(this).addClass("active");
    jQuery("#australiaReportTab").removeClass("active");

    jQuery("#third_in-depth").addClass("active");
    jQuery("#third_australia").removeClass("active");
  });

  jQuery(document).on("click", ".z_mainPopup button#z_removePopup", function(){
    jQuery(".z_mainPopup").removeClass("active");
  });


  jQuery(document).on("click", ".z_variant-container .variant-block", function () {
    var variant = jQuery(this);
    var variantValue = variant.attr("data-variantname");
    jQuery(".z_variant-container .variant-block").removeClass("active");

    // Find the label with the matching text (excluding visually hidden content)
    jQuery(".product-form__input label").each(function () {
        var labelText = jQuery(this).contents().filter(function () {
            return this.nodeType === 3; // Text node
        }).text().trim(); // Get only the text node content and trim whitespace

        if (labelText === variantValue) {
            jQuery(this).trigger("click");
            jQuery(variant).addClass("active");
        }
    });
  });
  
});